import script from "./TagCellElementLite.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagCellElementLite.vue?vue&type=script&setup=true&lang=ts"

import "./TagCellElementLite.vue?vue&type=style&index=0&id=6ef71ec0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ef71ec0"]])

export default __exports__